// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group-settings-view {
    box-sizing: content-box;
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
}
.group-settings-view__edit {
    padding: 20px;
    border: thin solid var(--primary-color-light);
    border-radius: 10px;
    background-color: white;
}
.group-settings-view__delete-your-account {
    margin: 10px auto;
    padding: 20px;
    border: thin solid var(--danger-color-light);
    background-color: var(--danger-color-lightest);
    border-radius: 10px;
}
.group-settings-view__update-post-permissions {
    margin: 10px auto;
    padding: 20px;
    border: thin solid var(--danger-color-light);
    background-color: var(--danger-color-lightest);
    border-radius: 10px;
}
.group-settings-view__delete-your-account .group-settings-view__explanation,
.group-settings-view__update-post-permissions .group-settings-view__explanation {
    padding: 10px;
}
.group-settings-view__delete-your-account .group-settings-view__button-wrapper, 
.group-settings-view__update-post-permissions .group-settings-view__button-wrapper {
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./client/pages/group/views/GroupSettingsView.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,aAAa;IACb,6CAA6C;IAC7C,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,4CAA4C;IAC5C,8CAA8C;IAC9C,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,4CAA4C;IAC5C,8CAA8C;IAC9C,mBAAmB;AACvB;AACA;;IAEI,aAAa;AACjB;AACA;;IAEI,kBAAkB;AACtB","sourcesContent":[".group-settings-view {\n    box-sizing: content-box;\n    width: 100%;\n    max-width: 600px;\n    margin: 0 auto;\n}\n.group-settings-view__edit {\n    padding: 20px;\n    border: thin solid var(--primary-color-light);\n    border-radius: 10px;\n    background-color: white;\n}\n.group-settings-view__delete-your-account {\n    margin: 10px auto;\n    padding: 20px;\n    border: thin solid var(--danger-color-light);\n    background-color: var(--danger-color-lightest);\n    border-radius: 10px;\n}\n.group-settings-view__update-post-permissions {\n    margin: 10px auto;\n    padding: 20px;\n    border: thin solid var(--danger-color-light);\n    background-color: var(--danger-color-lightest);\n    border-radius: 10px;\n}\n.group-settings-view__delete-your-account .group-settings-view__explanation,\n.group-settings-view__update-post-permissions .group-settings-view__explanation {\n    padding: 10px;\n}\n.group-settings-view__delete-your-account .group-settings-view__button-wrapper, \n.group-settings-view__update-post-permissions .group-settings-view__button-wrapper {\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
